export const SHOW_BOT_SECTION = "SHOW_BOT_SECTION";
export const CLOSE_BOT_SECTION = "CLOSE_BOT_SECTION";
export const PIN_BOT_SECTION = "PIN_BOT_SECTION";